import script from "./shipment-item-row.vue?vue&type=script&setup=true&lang=js"
export * from "./shipment-item-row.vue?vue&type=script&setup=true&lang=js"

import "./shipment-item-row.vue?vue&type=style&index=0&id=50caf28c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50caf28c"]])

export default __exports__